/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { ThemeType } from '../services/IndexPageReaderService';
import { TelemetryService } from '../services/TelemetryService';

const eventNamespace = 'global';

// see https://confluence.ops.expertcity.com/display/Arch/joinStart
interface JoinLaunchEvent {
  ev_name: string;
  ev_namespace: string;
  ga_id_sessiontracking: string;
  ga_meetingId: string;
  sa_endpointBuild: string;
  sa_method: string;
  sa_joinType: string;
  sa_launch_frontend: string;
  sa_timeWaitedForUserInput: number;
}

interface JoinStartEvent {
  ev_name: string;
  ev_namespace: string;
  ga_id_sessiontracking: string;
  ga_meetingId: string;
  sa_method: string;
}

export const sendJoinLaunchEvent = (
  telemetryService: TelemetryService,
  meetingId: string | undefined,
  sessionTrackingId: string,
  invokingMethod: string,
  joinType: string,
  endpointBuild: string,
  launchFrontend: ThemeType,
  timeWaitedForUserInput: number
): void => {
  const telemetryData: JoinLaunchEvent = {
    ev_name: 'joinLaunch',
    ev_namespace: eventNamespace,
    ga_id_sessiontracking: sessionTrackingId,
    ga_meetingId: meetingId || '',
    sa_endpointBuild: endpointBuild,
    sa_method: `${window.location.protocol}//${window.location.host}::${invokingMethod}`,
    sa_joinType: joinType,
    sa_timeWaitedForUserInput: timeWaitedForUserInput,
    sa_launch_frontend: launchFrontend,
  };
  telemetryService
    .event(telemetryData.ev_name, telemetryData)
    .then(telemetryService.flush);
};

export const sendJoinStartEvent = (
  telemetryService: TelemetryService,
  meetingId: string | undefined,
  sessionTrackingId: string
): void => {
  const telemetryData: JoinStartEvent = {
    ev_name: 'joinStart',
    ev_namespace: eventNamespace,
    ga_id_sessiontracking: sessionTrackingId,
    ga_meetingId: meetingId || '',
    sa_method: `${window.location.protocol}//${window.location.host}::joining_meeting`,
  };
  const promise = telemetryService.event(telemetryData.ev_name, telemetryData);
  promise.then(telemetryService.flush);
};
